import React from 'react'
import Shape from './Shape'

const Tooltip = (props) => (
  <Shape
    group={props.group}
    className={`gp-tooltip gp-box box-b2 ${props.className}`}
    style={props.style}
    events={props.events}
  >
    {props.content}
  </Shape>
)

Tooltip.defaultProps = {
  gorup: '',
  className: '',
  style: {}
}

export default Tooltip
